<script setup lang="ts">
const props = defineProps<{
	question: string
	answer: string
}>()

const isOpen = ref<boolean>(false)
</script>

<template>
	<ui-collapsible v-model:open="isOpen" class="flex flex-col gap-2">
		<ui-collapsible-trigger as="h3" class="group flex cursor-pointer items-center gap-2 font-semibold leading-none">
			<i-ph-plus-bold v-show="!isOpen" class="text-primary size-4 shrink-0 group-hover:text-black" />
			<i-ph-minus-bold v-show="isOpen" class="text-primary size-4 shrink-0 group-hover:text-black" />
			<span>{{ props.question }}</span>
		</ui-collapsible-trigger>

		<ui-collapsible-content as="p" class="text-muted-foreground pl-6 text-sm">
			{{ props.answer }}
		</ui-collapsible-content>
	</ui-collapsible>
</template>
